module.exports = __webpack_public_path__ + "static/img/pagenodata-bg.1b792c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/pagenodata-bg.png
// module id = vSNZ
// module chunks = 216